<!--
 * @Date: 2023-03-29 17:00:06
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditTime: 2023-05-12 10:55:33
 * @Description:
-->
<template>
  <div class="lc-tree">
    <el-tree
      ref="lcTreeRef"
      :data="treeData"
      :props="config.defaultProps"
      :show-checkbox="config.showCheckbox"
      :default-expand-all="config.expandAll"
      :node-key="config.nodeKey"
      @check="handleTreeCheckChange"
    />
  </div>
</template>
<script>

export default {
  name: 'LcTree',
  props: {
    value: {
      type: [Array],
      default: _ => []
    },
    treeData: {
      type: [Array],
      default: _ => []
    },
    config: {
      type: [Object],
      default: _ => {}
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val)) {
          this.$refs.lcTreeRef.setCheckedKeys(val)
        }
      }
    }
  },
  methods: {
    handleTreeCheckChange(currentNode, tree) {
      this.$emit('input', tree.checkedKeys)
      this.$emit('handleCheckChange', tree.checkedKeys)
    }
  }
}
</script>
